$(document).ready(function () {

  if($("body.template-product").length > 0){


    var indexBulSlide = '';
    $('.swiper-goods .swiper-wrapper > div').each(function(indx, element){
      // console.log($(this).hasClass('bulvideo'));
      if($(this).hasClass('bulvideo')){
        indexBulSlide = indx;
      }
    })
    // console.log(indexBulSlide);

    $("#goods-list_id0 .goods-type-btn").click(function () {
      $("#goods-list_id0 .goods-type-btn").removeClass("active");
      $(this).addClass("active");

      let result = $("#goods-list_id0 li.active").data('variant').split('|').filter(function(el) {return el.length !== 0}).map(row => {
        return row.split(',');
      });

      $('#optId').val(result[$('#goods-list_id1 .active').index()][1]);

      $(".about-line-box .select-color option").each(function(){
        if($('#optId').val() == $(this).val()){
          $(".about-line-box .select-color").val($(this).val());
          img = $(this).attr('data-images');
          $(".seletected-image").attr('src', img);
        }
      })
    });


    $("#goods-list_id1 .goods-type-btn").click(function () {
      $("#goods-list_id1 .goods-type-btn").removeClass("active");
      $(this).addClass("active");

      let result = $("#goods-list_id0 li.active").data('variant').split('|').filter(function(el) {return el.length !== 0}).map(row => {
        return row.split(',');
      });


      $('#optId').val(result[$('#goods-list_id1 .active').index()][1]);

      $(".about-line-box .select-color option").each(function(){
        if($('#optId').val() == $(this).val()){
          $(".about-line-box .select-color").val($(this).val());
          img = $(this).attr('data-images');

          $(".seletected-image").attr('src', img);
        }

      })

    });


    $(window).scroll(function() {
      var height = $(window).scrollTop();

      if(height > 400){
        $('.about .about-line').addClass('fixed');
          if($('.about .about-line').data('sticky_cart_mobile')){
            if($(window).width() <= 768){
              $('.dm-template').addClass('about-line-mobile-fixed');
            }
          }
          if($('.about .about-line').data('sticky_cart_desktop')){
            if($(window).width() >= 769){
              $('.dm-template').addClass('about-line-desktop-fixed');
            }
          }
      } else{
        $('.about .about-line').removeClass('fixed');
         if($('.about .about-line').data('sticky_cart_mobile')){
            if($(window).width() <= 768){
              $('.dm-template').removeClass('about-line-mobile-fixed');
            }
          }
          if($('.about .about-line').data('sticky_cart_desktop')){
            if($(window).width() >= 769){
              $('.dm-template').removeClass('about-line-desktop-fixed');
            }
          }
      }
    });

    // count goods
    $(".count-btn-minus").click(function () {
      var input = $(this).parents(".goods-count").find(".goods-count-input");
      var value = input.val();
      if (value != 0) {
        input.val(--value);
      }
    });
    $(".count-btn-plus").click(function () {
      var input = $(this).parents(".goods-count").find(".goods-count-input");
      var value = input.val();
      input.val(++value);    
    });

    // FAQs 
//     $(document).on('click', '.faq-title', function () {
//       var parent = $(this).parents(".faq-wrap");
//       var blockFaq = $(this).parents(".faq-block");
//       if (!$(blockFaq).hasClass("faq-active")) {
//         $(parent).find(".faq-block").removeClass("faq-active");
//         $(parent).find(".faq-info").slideUp();
//         $(blockFaq).addClass("faq-active");
//         $(blockFaq).find(".faq-info").slideDown();
//       }
//       else {
//         $(parent).find(".faq-block").removeClass("faq-active");
//         $(parent).find(".faq-info").slideUp();
//       }
//     });
    $(document).on('click', '.faq-title', function () {
      var blockFaq = $(this).parent(".faq-block");
        $(blockFaq).toggleClass("faq-active");
        $(blockFaq).find(".faq-info").slideToggle();
    });

    // select color
    var vals = $(".about-line-box .select-color").find('option:selected').attr('data-images');
    $(".about-line-box .seletected-image").attr('src', vals);

    $(".select-color").change(function () {
      var val = $(this).find('option:selected').attr('data-images');

      $(".seletected-image").attr('src', val);
    });

    setInterval(function(){ 
      $(".main-slider_dots li").removeClass("active");
      let slider = $(".product-single__main-new-product-template .slick-track li.slick-active").data("silder");                
      $(".main-slider_dots li." + slider).addClass("active");      
    }, 500);

    $(".main-slider_dots li").click(function(){
      let index = $(this).data("silder");
      // console.log(index);
      $('.product-single__thumbnails li.' + index + " a").click();
    });

    if ($(window).width() < 575) {
      var mobile_img = $(".single-goods .about-info").data("mobile_img");
      var mobile_name = $(".single-goods .about-info").find(".about-btn").data("name");
      $(".single-goods .about-info").removeAttr("style");
      if(mobile_img != ""){
        $(".single-goods .about-info").css('background-image', 'url(' + mobile_img + ')');
      }
      if(mobile_name != ""){
        $(".single-goods .about-info").find(".about-btn").text(mobile_name);
      }
    }

  }

  if($(".template-collection").length > 0){
    setInterval(function(){
      var cbhtml = $(".collection_product_banner").html();
      if($(".template-collection .boost-pfs-filter-products .collection_mid_banner").length == 0){
        $(".template-collection .boost-pfs-filter-products > div:nth-child(8)").after(cbhtml);
      }
    },500);

    var product_slide = {
      index : 0,
      init : function(){
//         $('.product_card_images:not(.slick-initialized)').slick({
//           slidesToShow:1,
//           slidesToScroll:1
//         });        
      }      
    };
    setInterval(function(){
      product_slide.init();
    },500);

    setInterval(function(){
      var procount = $(".filters-toolbar__product-count.boost-pfs-filter-total-product").text().split(" ");
      var procollection = $(".filters-toolbar__product-count.boost-pfs-filter-total-product").data("collection");
      $(".filters-toolbar__product-count.boost-pfs-filter-total-product").html("<strong>" + procount[0] + "</strong> " + procollection);      
    },100);
  }  
  if($(".template-page").length > 0){
  
  	$(document).on('click', '.faq-title', function () {
      var parent = $(this).parents(".faq-wrap");
      var blockFaq = $(this).parents(".faq-block");
      if (!$(blockFaq).hasClass("faq-active")) {
        $(parent).find(".faq-block").removeClass("faq-active");
        $(parent).find(".faq-info").slideUp();
        $(blockFaq).addClass("faq-active");
        $(blockFaq).find(".faq-info").slideDown();
      }
      else {
        $(parent).find(".faq-block").removeClass("faq-active");
        $(parent).find(".faq-info").slideUp();
      }
    });
  }
    
$(document).on('click','.mobile_nav_toggle', function(){
  const isOpen = $(this).hasClass('is_active');

  if (isOpen) {
    $("body").removeClass('mobile_nav_open');
    $(this).removeClass("is_active");
    $(".new-header .desktop_nav_wrapper").removeClass("is_active");
    $('.mobile_nav_wrapp').removeClass('mobile_nav_open');
    $('.wh-btn').removeClass('mobile_nav_open');
    $('.menu_overlay').removeClass('active_overlay');
  } else {
    $("body").addClass('mobile_nav_open');
    $(this).addClass("is_active");
    $(".new-header .desktop_nav_wrapper").addClass("is_active");
    $('.mobile_nav_wrapp').addClass('mobile_nav_open');
    $('.wh-btn').addClass('mobile_nav_open');
    $('.menu_overlay').addClass('active_overlay');
  }
});



  
  $('.mobile_nav_main_links[data-current-header="0"] .header_close .close_btn,#shopify-section-header-blog .header_close').click(function(){    
    $('body').removeClass('mobile_nav_open');
    $(".mobile_nav_toggle").removeClass('is_active');
    $(".new-header .desktop_nav_wrapper").removeClass('is_active');
    $('.mobile_nav_wrapp').removeClass('mobile_nav_open');
    $('.wh-btn').removeClass('mobile_nav_open');
    $('.menu_overlay').removeClass('active_overlay');
  });
  
  $('.menu_overlay').click(function(){    
    $(".mobile_nav_toggle").removeClass('is_active');
    $(".new-header .desktop_nav_wrapper").removeClass('is_active');
    $('body').removeClass('mobile_nav_open');
    $('.mobile_nav_wrapp').removeClass('mobile_nav_open');
    $('.wh-btn').removeClass('mobile_nav_open');
    $('.menu_overlay').removeClass('active_overlay');
  });
  
  // $('.mobile_nav_contain li.has_drop_down').click(function(){
  //   $(this).toggleClass('mobile_active_drop');
  //   if($(this).hasClass('mobile_active_drop')){
  //     $(this).next('ul').slideDown();
  //     if($(this).parents('.level_1').length == 0){
  //     $(this).siblings('li').hide();
  //     }
  //   }else{
  //     $(this).next('ul').slideUp();
  //     $(this).siblings('li').fadeIn(1500);
  //   }    
  // });
  
  $('#user_icon_model').click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      $('.nav_link_wrap').removeClass('active');
      $('.mobile_user_model').addClass('active');
    }else{
      $('.nav_link_wrap').addClass('active');
      $('.mobile_user_model').removeClass('active');
    }
  });
  
  /** PDP - Swatches **/
  $(document).on('click', '.option-selector', function () {
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).parents('.customOptionBlock').find('.option-dropdown').removeClass('active');
    }else{
      $('.option-dropdown').removeClass('active');
      $('.option-selector').removeClass('active');
      $(this).addClass('active');
      $(this).parents('.customOptionBlock').find('.option-dropdown').addClass('active');
    }
  });
  $(document).on('click', function (e) {
    var container = $(".customOptionBlock");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.option-dropdown').removeClass('active');
      $('.option-selector').removeClass('active');
    }
  });

  $(document).on('click', '.option-dropdown label', function () {
//     $(this).parent().removeClass('active');
    var $optionSelector = $(this).parents('.customOptionBlock').find('.option-selector');
//     $optionSelector.removeClass('active');
    var imgSrc = $(this).find('img').attr('src');
    var optionValue = $(this).find('span.label-value:not(.option_img)').text();
    // console.log(optionValue,$(this).find('span.label-value:not(.option_img)'))
    var $selectedOption = $optionSelector.find('.option-selector__selected');
    $selectedOption.find('img').attr('src', imgSrc);
    $selectedOption.find('span').text(optionValue);

    // Sticky CTA
    // var value = $(this).attr('data-value');
    // var option = $(this).parent().attr('data-option');
    // var stickyValue = $(`.about-line-box .select-color[data-option="${option}"] option:selected`).text();
    // var mobileValue = $(`.product_info_sec .select-color[data-option="${option}"] option:selected`).text();
    // console.log(optionValue,option,stickyValue,mobileValue);
    // if (optionValue != stickyValue) {
    //   $(`.about-line-box .select-color[data-option="${option}"] [data-value="${value}"]`).prop('selected', true);
    //   $(`.about-line-box .select-color[data-option="${option}"]`).trigger('change');
    // }
    // if (optionValue != mobileValue) {
    //   $(`.product_info_sec .select-color[data-option="${option}"] [data-value="${value}"]`).prop('selected', true);
    //   $(`.product_info_sec .select-color[data-option="${option}"]`).trigger('change');
    // }
  });
  
  $(document).on('change', '.about-line-box .select-color', function () {
    var $selectedOption = $(this).find('option:selected');
    var imgSrc = $selectedOption.attr('data-image');
    var optionValue = $selectedOption.text();
    $(this).parent().find('.selected-color img').attr('src', imgSrc);
    $(this).parent().find('.selected-color img').attr('alt', optionValue);
    
    // Main CTA
    var option = $(this).attr('data-option');
    var value = $selectedOption.attr('data-value');
    $(`.option-dropdown[data-option="${option}"] label[data-value="${value}"]`).trigger('click');
  });
  
  $(document).on('change', '.product_info_sec .select-color', function () {
    var $selectedOption = $(this).find('option:selected');
    var imgSrc = $selectedOption.attr('data-image');
    var optionValue = $selectedOption.text();
    $(this).parent().find('.selected-color img').attr('src', imgSrc);
    $(this).parent().find('.selected-color img').attr('alt', optionValue);

    // Main CTA
    var option = $(this).attr('data-option');
    var value = $selectedOption.attr('data-value');
    $(`.about-line-box .select-color[data-option="${option}"] [data-value="${value}"]`).prop('selected', true);
    $(`.about-line-box .select-color[data-option="${option}"]`).trigger('change');
  });

  $(document).on('click', '.about-line-box .goods-list-btns[data-option="grosse"] label', function () {
    var bValue = $(this).attr('data-value');
    $(`.product_info_sec .option-dropdown[data-option="grosse"] label[data-value="${bValue}"]`).trigger('click');
  });

  $(window).resize(function () {
    var height = document.querySelector('.header_two').offsetHeight;
    document.documentElement.style.setProperty('--header-height', height + 'px');
    // var menuHeight = 0;
    // menuHeight = window.innerHeight - document.querySelector('.mobile_nav_header').offsetHeight - document.querySelector('.mobile_nav_footer').offsetHeight;
    // document.documentElement.style.setProperty('--menu-height', menuHeight + 'px');
  });

  $(document).on('change', '.product_info_sec .goods-count-input', function() {
    var inputValue = $(this).val();
    $('.purchase-box .green-btn-quntity').text(inputValue);
  });
  
  $(document).on('click', '.js-sticky-atc', function () {
    $('[data-add-to-cart]').trigger('click');
  });
  
  $(window).scroll(function () {
    if($(".header_two").hasClass("new-header") == false){
      if (window.scrollY > document.querySelector('.header_two').offsetHeight) {
        $('.nav-link__mega').addClass('inactive');
        // console.log("done")
      }
    }
    else {
      $('.nav-link__mega').removeClass('inactive');
      var height = document.querySelector('.header_two').offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  });

  
  

    // slider goods
    if ($('.swiper-goods').length > 0) {
      var swiperGoods = new Swiper('.swiper-goods', {
        loop: true,
        pagination: {
          el: '.swiper-pagination-goods',
          clickable: true
        },
        navigation: {
          prevEl: '.goods-slider-prev',
          nextEl: '.goods-slider-next'
        },
        autoHeight: false
      });
    }

  
});

// if($('.about-new').length > 0){
//   $(window).scroll(function(){
//     if ($(this).scrollTop() < $('.about-new').position().top) {
//         $('.about-new .purchase-box').removeClass('fixed');
//     } else {
//       // var getSelector = '';
//       // if($('.product_banner--section').length >= 1){
//       //   getSelector = $('.new_product_template .dm-product-banner').parents('.product_banner--section').next('.shopify-section');
//       // }else{
//       //   getSelector = $('.new_product_template .Product_bottom_info').parents('.product-info-new').next('.shopify-section');
//       // }
      
//       var getSelector = $('.new_product_template .Product_bottom_info').parents('.product-info-new').next('.shopify-section');
      
//       if($(this).scrollTop() < getSelector.position().top - 700){
//         $('.about-new .purchase-box').css('width',$('.about-new .purchase-box-inner').width() + 'px');
//         $('.about-new .purchase-box').addClass('fixed');
//       }else{
//         $('.about-new .purchase-box').removeClass('fixed');
//       }
//     }
//   });
// }


if($('.about-new').length > 0){
  $(window).scroll(function(){
    if ($(this).scrollTop() < $('.about-new').position().top) {
        $('.about-new .purchase-box').removeClass('fixed');
    } else {          
      var getSelector = $('.new_product_template .Product_bottom_info');      
      if($(this).scrollTop() < getSelector.position().top - 730){
        $('.about-new .purchase-box').css('width',$('.about-new .purchase-box-inner').width() + 'px');
        $('.about-new .purchase-box').addClass('fixed');
      }else{
        $('.about-new .purchase-box').removeClass('fixed');
      }
    }
  });
}






// document.documentElement.style.setProperty('--header-height', document.querySelector('.header_two header').offsetHeight + 'px');
// var menuHeight = 0;
// menuHeight = window.innerHeight - document.querySelector('.mobile_nav_header').offsetHeight - document.querySelector('.mobile_nav_footer').offsetHeight;
// document.documentElement.style.setProperty('--menu-height', menuHeight + 'px');

   // Product Lightbox Popup Js

$('.product-single__main .product-single__main-item a').click(function(e){
  e.preventDefault();
});

// Custom Video Player
var player;
var getVideoID = document.querySelector('.auto-play-video-part')?.dataset.videoId;

if (!window.YT) {
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);
}

window.onYouTubeIframeAPIReady = function () {
  player = new YT.Player('player', {
    height: '100%',
    width: '100%',
    videoId: getVideoID,
    playerVars: {
      playsinline: 1,
      autoplay: 1,
      mute: 1,
      loop: 1,
      controls: 0,
      playlist: getVideoID,
      rel: 0
    },
    events: {
      onReady: function(e){
        e.target.playVideo();
      }
    }
  });
};

function pauseVideo(){
  if(player) player.pauseVideo();
}

function playVideo(){
  if(player) player.playVideo();
}

$(document).on('click','.custom_video_inner .video-control__pause',function(){
  pauseVideo();
  $(this).hide();
  $('.custom_video_inner .video-control__play').css('display','flex');
  $('.video__image').addClass('active');
});

$(document).on('click','.custom_video_inner .video-control__play',function(){
  playVideo();
  $(this).hide();
  $('.video__image').removeClass('active');
  $('.custom_video_inner .video-control__pause').css('display','flex');
});

document.addEventListener("DOMContentLoaded", function () {
  // run only if NOT on index page
  if (!document.body.classList.contains("template-index")) {
    if (document.querySelectorAll("[data-fancybox='gallery']").length > 0) {
      Fancybox.bind('[data-fancybox="gallery"]', {
        Thumbs: false,
        Toolbar: false,
        closeButton: "top",
      });
    }
  }
});
$(function() {
  $('.psp-accordion .tab_name').click(function(){
    $(this).toggleClass('tab_active').next('.tab_content').slideToggle();
  });
  $('.expandable-content__toggle').click(function(){
    $(this).toggleClass('open-expand').parents('.tab_content').toggleClass('expand')
  });
  $('.shipping-popup').click(function(){
    $('.pay-shipping-popup-main').show();
    $('.psp-accordion .tab_content').each(function(){
      let heightContent = $(this).innerHeight();
      heightContent >= 100 ? $(this).addClass("expandable-content--expandable") : $(this).removeClass('expandable-content--expandable');
    });
  });
  $('.psp-colse-btn').click(function(){
    $('.pay-shipping-popup-main').hide();
  })
});

// Out Side Click Close Popup JS
$(document).mouseup(function(e) {
  var container = $(".psp-modal-main-content");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.pay-shipping-popup-main').hide();
  }
});
setTimeout(function(){
  	product_resize();
  },1000);
$(window).resize(function(){
  setTimeout(function(){
    product_resize();
  },30);
});  

function product_resize(){
  var maxHeight = 0;
  $(".product-card").each(function(){
    if ($(this).find('.product-card_inner').outerHeight() > maxHeight) { maxHeight = $(this).find('.product-card_inner').outerHeight(); }
  });
  $(".product-card").height(maxHeight);
  var maxHeightimg = 0;
  $(".template-collection .product-card .product_card_images").each(function(){
    if ($(this).find('.product-card__image-with-placeholder-wrapper').height() > maxHeightimg) { maxHeightimg = $(this).find('.product-card__image-with-placeholder-wrapper').height(); }
  });
  $(".template-collection .product-card .product_card_images").height(maxHeightimg);
  var maxHeighttitle = 0;
  $(".template-collection .product-card .product-card__title").each(function(){
    if ($(this).find('>span').outerHeight() > maxHeighttitle) { maxHeighttitle = $(this).find('>span').outerHeight(); }
  });
  $(".template-collection .product-card .product-card__title").height(maxHeighttitle);
}
  

if($(window).width() < 481) {
  $('.banner_badges').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    centerMode: true,
    slidesToScroll: 1
  });
  $('.template__natural-stone .collection-grid .grid').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    centerMode: true,
    slidesToScroll: 1
  });

// $(window).scroll(function() {
//       var whheight = $(window).scrollTop();

//       if(whheight > 400){
//           $('.wh-btn').addClass('fixed');
//       } else{
//            $('.wh-btn').removeClass('fixed');
//       }
//     });
    
}

// $(document).ready(function () {  
//   var itemnmb = $('.product-single__main .swiper-slide.swiper-slide-active .product-single__main-item').data('slide-number');
//   $('.slide_counter .current_slide').html(itemnmb);
//   $(".product-single__main .swiper-wrapper").on("afterChange", function (){
//     var itemnmb = $('.product-single__main .swiper-slide.swiper-slide-active .product-single__main-item').data('slide-number');
//     $('.slide_counter .current_slide').html(itemnmb);
//   });
// });

// New JS | 27-07-2022

if(document.querySelector('.header_two') != null){
    var height = document.querySelector('.header_two').offsetHeight  - window.scrollY;
    document.documentElement.style.setProperty('--header-height', height + 'px');
    $(window).scroll(function () {
      if (window.scrollY <= 40) {
        $('.header_two').parent().removeClass('header__sticky');
      }else{
        $('.header_two').parent().addClass('header__sticky');
      }
      $('.nav-link__mega').removeClass('inactive');
      setTimeout(function(){
        var height = document.querySelector('.header_two').offsetHeight;
        document.documentElement.style.setProperty('--header-height', height + 'px');
      },50);
    });
    $(window).resize(function () {
      var height = document.querySelector('.header_two').offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
      // var menuHeight = 0;
      // menuHeight = window.innerHeight - document.querySelector('.mobile_nav_header').offsetHeight - document.querySelector('.mobile_nav_footer').offsetHeight;
      // document.documentElement.style.setProperty('--menu-height', menuHeight + 'px');
    });
}

unWrapper()
$(window).resize(function(){
  unWrapper()
})
function unWrapper(){
  if($(window).width() < 749){
    $(".main-collection_wrapper:not(.selected_collection):not(.new-dm-collection) #Collection .collection-matrix li,#Collection .collection-matrix ul.with-bg").unwrap()
    $(".main-collection_wrapper:not(.selected_collection):not(.new-dm-collection) #Collection li.grid__item--collection-template").wrapAll('<ul class="grid grid--uniform grid--view-items collection-matrix collection__page-grid">')    
    $(".main-collection_wrapper:not(.selected_collection):not(.new-dm-collection) #Collection li.grid__item").wrapAll('<ul class="grid grid--uniform grid--view-items collection-matrix">')    
  }
}




// $(".new-header .nav_links.has_drop_down").mouseenter(function(e) {
//     e.preventDefault();
//   $(".nav-link__top").removeClass("mega-active");
//   $(".new-header .nav_links.has_drop_down").removeClass("mega-active");
//   // $('body').addClass('mobile_nav_open');
//   $(this).siblings(".nav_links.has_drop_down").find(".nav-link__mega").removeClass("mega-active");
//   $(this).find(".nav-link__mega").addClass("mega-active");
//   $(this).children(".nav-link__top").addClass("mega-active");
//   $('.menu_overlay').addClass('active_overlay');
//   $(".mobile_nav_toggle").removeClass('is_active');
//   $(".new-header .desktop_nav_wrapper").removeClass('is_active');
//   $('.mobile_nav_wrapp').removeClass('mobile_nav_open');
//   $('body').addClass('mega-menu-open');
// })
// $(".new-header .content_wrapper").mouseleave(function(e) {
//   $('body').removeClass('mobile_nav_open');
//   $(this).closest(".nav_links.has_drop_down").find(".nav-link__mega").removeClass("mega-active");
//   $(this).find(".nav-link__top").removeClass("mega-active");
//   $(this).find(".nav-link__mega").removeClass("mega-active");
//   $('.menu_overlay').removeClass('active_overlay');
//   $('body').removeClass('mega-menu-open');
// })

// Hover on items WITH dropdown
if($(window).width() > 991) {
    $(".new-header .nav_links.has_drop_down").mouseenter(function (e) {
      e.preventDefault();
    
      // Reset all
      $(".nav-link__top").removeClass("mega-active");
      $(".new-header .nav_links.has_drop_down").removeClass("mega-active");
      $(".new-header .nav_links.has_drop_down .nav-link__mega").removeClass("mega-active");
    
      // Activate current
      $(this).find(".nav-link__mega").addClass("mega-active");
      $(this).children(".nav-link__top").addClass("mega-active");
    
      // UI updates
      $(".menu_overlay").addClass("active_overlay");
    //   $(".mobile_nav_toggle").removeClass("is_active");
      $(".new-header .desktop_nav_wrapper").removeClass("is_active");
      $(".mobile_nav_wrapp").removeClass("mobile_nav_open");
      $("body").addClass("mega-menu-open");
    });
    
    // When mouse leaves the entire nav area
    $(".new-header .content_wrapper").mouseleave(function () {
      // Reset everything (works for both with/without submenu)
      $(".nav-link__top").removeClass("mega-active");
      $(".nav-link__mega").removeClass("mega-active");
      $(".new-header .nav_links.has_drop_down").removeClass("mega-active");
      $(".menu_overlay").removeClass("active_overlay");
      $("body").removeClass("mega-menu-open mobile_nav_open");
    });
    
    // Also: if user clicks on a nav item WITHOUT dropdown, close mega menu
    $(".new-header .nav_links:not(.has_drop_down)").mouseenter(function () {
      $(".nav-link__top").removeClass("mega-active");
      $(".nav-link__mega").removeClass("mega-active");
      $(".new-header .nav_links.has_drop_down").removeClass("mega-active");
      $(".menu_overlay").removeClass("active_overlay");
      $("body").removeClass("mega-menu-open mobile_nav_open");
    });
}




$(".new-header .nav_links.has_drop_down .mega-menu-close-btn").click(function(){
  $('body').removeClass('mobile_nav_open');
  $(this).closest(".nav_links.has_drop_down").find(".nav-link__mega").removeClass("mega-active");
  $(this).parents(".nav_links.has_drop_down").find(".nav-link__top").removeClass("mega-active");
})

  


$(".new-header .nav_links.has_drop_down .collection_type_url").mouseenter(function(){
  var getcollImage = $(this).data("hover-collection-image");
  var getcollImageurl = $(this).data("image-url");
  $(".new-header .nav_links.has_drop_down .mega-menu__block--image .mega-menu__image").addClass("is_active");
  setTimeout(function(){
    $(".new-header .nav_links.has_drop_down .mega-menu__block--image .mega-menu__image").attr('src',getcollImage);
    $(".new-header .nav_links.has_drop_down .mega-menu__block--image .mega-menu__overlay__link").attr('href',getcollImageurl);
    $(".new-header .nav_links.has_drop_down .mega-menu__block--image .mega-menu__image").removeClass("is_active");
  },300)
})


$(".collection_title").click(function(){
  var getCollectionHendle = $(this).data("btn-collection-handel");
  var getCollectionPCount = $(this).data("product-count");
  $(".collection_title").not($(this)).removeClass("active");
  $(".collection-product-list").not($(".collection-product-list[data-collection-handel="+getCollectionHendle+"]")).removeClass("active");
  $(this).toggleClass("active");
  $(".collection-product-list[data-collection-handel="+getCollectionHendle+"]").toggleClass("active");
  $(".collection-product-count .p_count").html(getCollectionPCount);    
})

$(".header_close .back_btn").click(function() {
  $(".mobile_nav_links_wrapper.lavel_2 .custom_mobile_links").trigger("click");
})

// $('.mobile_nav_contain .custom_mobile_links').click(function(){
// // alert("here....")
//   console.log("test............")
//   $(this).toggleClass('mobile_active_drop');
//   var getLevel =  $(this).data("level");
//   $(this).parents(".main-navigation-mobile-stage").attr("data-current",getLevel);
//   $(this).parents(".mobile_nav_main_links").attr("data-current-header",getLevel)
//   $(".mobile_nav_links_wrapper.lavel_2").css("display", "none");
//   $("."+$(this).data("link-handle")+"").css("display", "block");
// });
// console.log(document.querySelectorAll('.mobile_nav_contain .custom_mobile_links'),"document.querySelectorAll('.mobile_nav_contain .custom_mobile_links')")
// document.querySelectorAll('.mobile_nav_contain .custom_mobile_links').forEach(function(element) {
//   element.addEventListener('click', function() {
//     this.classList.toggle('mobile_active_drop');
    
//     var getLevel = this.getAttribute("data-level");
    
//     var mainNavStage = this.closest(".main-navigation-mobile-stage");
//     if (mainNavStage) {
//       mainNavStage.setAttribute("data-current", getLevel);
//     }
//     var mainNavLinks = this.closest(".mobile_nav_main_links");
//     if (mainNavLinks) {
//       mainNavLinks.setAttribute("data-current-header", getLevel);
//     }
//     document.querySelectorAll(".mobile_nav_links_wrapper.lavel_2").forEach(function(wrapper) {
//       wrapper.style.display = "none";
//     });

//     var linkHandleClass = this.getAttribute("data-link-handle");
//     var linkElement = document.querySelector(".mobile_nav_links_wrapper." + linkHandleClass);
//     if (linkElement) {
//       linkElement.style.display = "block";
//     }
//   });
// });



// $(document).on('click','.chat-btn',function(){
//     $(".intercom-lightweight-app .intercom-lightweight-app-launcher-icon-open").click();
//     const iframe = document.querySelector('.intercom-app .intercom-launcher-frame');
//     if(iframe != "null"){
//         const iframeContent = iframe?.contentDocument || iframe?.contentWindow.document;
//         if (iframeContent) {
//           const elementInsideIframe = iframeContent?.querySelector('.intercom-launcher [data-testid="launcher-default-open-icon"]');
//           if (elementInsideIframe) {
//             elementInsideIframe?.click();
//           }
//         }
//     }
// })

// const checkInterval = setInterval(checkDivExistence, 1000);

// function checkDivExistence() {
//   const divElement = document.querySelector(".intercom-lightweight-app");
//   if (divElement !== null) {
//     var slectorShow = document.querySelectorAll(".chat-btn");
//     slectorShow.forEach(function(element){
//       element.classList.add("active")
//     })
//     clearInterval(checkInterval);
//   }
// }


// New Home page Image With Text
$('.image-with-text__media-slider').not(".slick-initialized").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>'
});

$(document).ready(function(){
  if($(window).width() > 991){
    $('.product-form__input--box').hover(
      function() {
        $(this).addClass('selected');
        $('.product-form__input--box').not(this).addClass('not-selected');
      },
      function() {
        $(this).removeClass('selected');
        $('.product-form__input--box').removeClass('not-selected');
      }
    );
  }

  $('.product-form__input--box').click(function (e) {
    e.stopPropagation(); // Prevent click event from bubbling up

    // Toggle classes on the clicked element
    const isSelected = $(this).hasClass('selected');
    $('.product-form__input--box').removeClass('selected not-selected');
    $('.product-form__input--box-wrapper').removeClass('active');

    if (!isSelected) {
      $(this).addClass('selected');
      $('.product-form__input--box').not(this).addClass('not-selected');
      $(this).closest('.product-form__input--box-wrapper').addClass('active');
    }
  });

  // Handle click outside functionality
  $(document).click(function (e) {
    if (!$(e.target).closest('.product-form__input--box-wrapper').length) {
      $('.product-form__input--box').removeClass('selected not-selected');
      $('.product-form__input--box-wrapper').removeClass('active');
    }
  });
  
});


$(document).on('click', '.quantity .quantity__button', function () {
    var selfType = $(this).attr('data-type'); 
    var $input = $(this).siblings('.quantity__input');
    var quantityVal = parseInt($input.val(), 10); 

    if (selfType === 'plus') {
        quantityVal += 1; 
    } else if (selfType === 'minus' && quantityVal > 1) {
        quantityVal -= 1; 
    }

    $input.val(quantityVal);
    var price = $('.product-form-price-subtotal span').attr('data-price');
    var subtotal =  price * quantityVal;
    $('.product-form-price-subtotal span').html(theme.Currency.formatMoney(subtotal, theme.moneyFormat));
});

$('.products-benefit-inner .products-benefit__image').not(".slick-initialized").slick({
  dots: false,
  infinite: true,
  slidesToShow: 1,
  fade: true,
  prevArrow: '<button data-aos="fade-down" data-aos-duration="200" class="slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></svg></button>',
  nextArrow: '<button data-aos="fade-down" data-aos-duration="200" class="slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/></svg></button>',
});



if (document.body.classList.contains('template__dm-product')) {
  (function waitForRatings() {
    let intervalId = setInterval(() => {
      const ratingElements = document.querySelectorAll('.product-single__meta .ruk-rating-snippet-count');
  
      if (ratingElements.length > 0) {
        const parent = ratingElements[0].parentNode;
  
        if (!parent.querySelector('.ruk-rating-snippet-count-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('ruk-rating-snippet-count-wrapper');
  
          const firstRatingElement = ratingElements[0];
          const secondRatingElement = ratingElements[1];
          // console.log(firstRatingElement,'firstRatingElement',secondRatingElement);
          if (firstRatingElement && secondRatingElement) {
            let countText = firstRatingElement.textContent.replace(/[()]/g, '').trim();
            let ratingText = secondRatingElement.textContent.trim();
            let ratingValue = ratingText.split('/')[0].trim();
  
            // if (document.body.classList.contains('template__dm-product') && window.innerWidth <= 768) {
            //   const mobileSpan = document.createElement('span');
            //   mobileSpan.className = 'ruk-rating-snippet-count';
            //   mobileSpan.textContent = `(${countText.match(/\d+/) ? countText.match(/\d+/)[0] : countText})`; 
            //   wrapper.appendChild(mobileSpan);
            // } 
            // else {
            // }
              const ratingSpan = document.createElement('span');
              ratingSpan.className = 'ruk-rating-snippet-count';
              ratingSpan.innerHTML = `<b>${ratingValue}</b> aus`;
  
              const countSpan = document.createElement('span');
              countSpan.className = 'ruk-rating-snippet-count';
              countSpan.style.marginLeft = '5px';
              countSpan.textContent = countText;
  
              wrapper.appendChild(ratingSpan);
              wrapper.appendChild(countSpan);
  
            firstRatingElement.remove();
            secondRatingElement.remove();
  
            parent.appendChild(wrapper);
          }
  
          clearInterval(intervalId);
        }
      }
    }, 1000);
  })();
}else{
  (function waitForRatings() {
    let intervalId = setInterval(() => {
      const ratingElements = document.querySelectorAll('.product-single__meta .ruk-rating-snippet-count');

      if (ratingElements.length > 0) {
        const parent = ratingElements[0].parentNode;

        if (!parent.querySelector('.ruk-rating-snippet-count-wrapper')) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('ruk-rating-snippet-count-wrapper');

          const firstRatingElement = ratingElements[0];
          if (firstRatingElement) {
            const text = firstRatingElement.textContent.trim();

            // Extract number from text e.g. (44 Kundenbewertungen) -> 44
            const countMatch = text.match(/\d+/);
            const count = countMatch ? parseInt(countMatch[0], 10) : 0;

            let updatedText;
              // Desktop normal pages → singular/plural handling
              if (count === 1) {
                updatedText = `(${count} Bewertung)`;
              } else {
                updatedText = `(${count} Bewertungen)`;
              }

            firstRatingElement.textContent = updatedText;

            // ✅ Add class to .product-single__meta if count = 1
            const metaElement = document.querySelector('.goods-info-review');
            if (metaElement) {
              if (count === 1) {
                metaElement.classList.add('one-review');
              } else {
                metaElement.classList.remove('one-review');
              }
            }
          }

          wrapper.appendChild(firstRatingElement);

          const secondRatingElement = ratingElements[1];
          if (secondRatingElement) wrapper.appendChild(secondRatingElement);

          parent.appendChild(wrapper);
        }

        clearInterval(intervalId);
      }
    }, 1000);
  })();
}



// (function waitForRatings() {
//   const intervalDelay = 200;
//   const maxAttempts = 50; // safety cap (10s max if 200ms)
//   let attempts = 0;

//   const intervalId = setInterval(() => {
//     attempts++;

//     const ratingElements = document.querySelectorAll(
//       '.product-single__meta .ruk-rating-snippet-count'
//     );

//     if (ratingElements.length > 0) {
//       const parent = ratingElements[0]?.parentNode;
//       if (parent && !parent.querySelector('.ruk-rating-snippet-count-wrapper')) {
//         const wrapper = document.createElement('div');
//         wrapper.className = 'ruk-rating-snippet-count-wrapper';

//         // Append first + second rating elements (if they exist)
//         [ratingElements[0], ratingElements[1]].forEach(el => el && wrapper.appendChild(el));

//         parent.appendChild(wrapper);
//       }
//       clearInterval(intervalId);
//     }

//     if (attempts >= maxAttempts) {
//       clearInterval(intervalId); // stop trying after safety cap
//       console.warn('Ratings not found within timeout.');
//     }
//   }, intervalDelay);
// })();







// remove text in io reviews snippet
(function waitForMbRatings() {
  let intervalId = setInterval(() => {
    let sliderItems = document.querySelectorAll(
      '.productGridShow .grid__item, .collection_items_wrapper .grid__item, .section-feature-product-slider .product-tab-content__item'
    );

    if (sliderItems.length > 0) {
      let allProcessed = true;

      sliderItems.forEach((item) => {
        let ratingElement = item.querySelector('.ruk-rating-snippet-count');
        if (ratingElement) {
          // Replace both 'Kundenbewertungen' and 'Bewertungen'
          ratingElement.innerHTML = ratingElement.innerHTML
            .replace(/Kundenbewertungen/g, '')
            .replace(/Bewertungen/g, '')
            .replace(/Bewertung/g, '')
            .replace(" ", '')
            .trim();

          clearInterval(intervalId); // <- careful, this stops after first match
        } else {
          allProcessed = false;
        }
      });

      // Better: clear interval only if all items are processed
      if (allProcessed) {
        clearInterval(intervalId);
      }
    }
  }, 1000);
})();







$(document).on('change','.product-form__input--box .customOptionBlock input[type="radio"]',function(){
   var itsVal = $(this).val();
   var mobileVal = $(this).val().toLowerCase().replace(/\s+/g, '-'); 
   var $parentBox = $(this).parents('.product-form__input--box');
   var $allBoxes = $('.product-form__input--box'); 
   $(this).parents('.product-form__input-box__inner').find('[data-selected-value]').text(itsVal); 

  
   // $(this).parents('.product-form__input--box').removeClass('selected'); 

   // $parentBox.removeClass('selected')
   // $parentBox.addClass('not-selected');


    // $allBoxes.removeClass('selected not-selected');
    // $('.product-form__input--box-wrapper').removeClass('active');

    // Update the current and next box
    // $parentBox.addClass('not-selected');
    // $parentBox.removeClass('selected');
    // var $nextBox = $parentBox.next('.product-form__input--box');
    // if ($nextBox.length) {
    //   $nextBox.addClass('selected')
    //   $nextBox.removeClass('not-selected');
    // }
    if($(window).width() < 991){
      $('.product-form__input--box').removeClass('selected');
      $('.product-form__input--box').removeClass('not-selected');

      

      $($parentBox).find('.mobile-product-variant .variant-item').each(function(){
        var selfVal = $(this).attr('data-value').toLowerCase().replace(/\s+/g, '-');
        // console.log(mobileVal,'mobileVal',selfVal);
        if (mobileVal === selfVal) {
            $(this).addClass('selected');
        } else {
            $(this).removeClass('selected');
        }
      });
    }
});

// $(document).on('click','.product-form__input--box .customOptionBlock label',function(){
//     console.log('innn');
//     if($(window).width() < 991){
//       $('.product-form__input--box').removeClass('selected');
//       $('.product-form__input--box').removeClass('not-selected');
//     }
// });

$("header").mouseleave(function(){
  $(".language_btn").removeClass("open");
  $(".custom_language-options").removeClass("open");
  $(".searchbar").removeClass("focus-active");
  $(".search__results-wrapper").css("display","none");
  $("body").removeClass("mobile_nav_open");
});

function indexCollectionSlider() {
  if ($(window).width() > 750) {
    $('.index-featured-collection .productGridShow').each(function () {
      if (!$(this).hasClass("slick-initialized")) {
        var arrowButton = $(this).attr('data-button') === 'true';
        $(this).slick({
          dots: false,
          infinite: true,
          centerMode: true,
          centerPadding: '150px',
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: arrowButton,
          prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
          responsive: [
            {
              breakpoint: 1201,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 949,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
      }
    });
  } else {
    $('.index-featured-collection .productGridShow.slick-initialized').slick('unslick');
  }
}

indexCollectionSlider();

function indexCollectionMobileSlider(){
  if($(window).width() <= 991){
    $('.index-featured-collection .featured-collection-mobile-slider').not(".slick-initialized").each(function() {
      $(this).slick({
          dots: false,
          infinite: false,
          centerMode: true,
          centerPadding: '60px',
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
                centerMode: false
              }
            }
          ]
      });
    });
  }
}
indexCollectionMobileSlider();

let resizeTimer;
$(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    indexCollectionSlider();
    indexCollectionMobileSlider();
  }, 200);
});

// Index Page collection tab slider
function collectionTabSlider(){
  $('.tab-collection-list').not(".slick-initialized").slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: '150px',
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 1181,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          centerPadding: '60px',
        }
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 1,
          centerPadding: '15px',
        }
      }
    ]
  });
}
collectionTabSlider();
$(document).on('click','.collection-tab-title .tab-link', function() {
  var dataIndex = $(this).attr('data-index');
  $('.collection-tab-item').removeClass('active');
  $(this).parents('.collection-tab-item').addClass('active');
  $('.collection-tab-content .collection-tab-content-wrap').each(function(){
      var selfIndex = $(this).attr('data-index');
      if(dataIndex == selfIndex){
         $(this).addClass('active'); 
      }else{
         $(this).removeClass('active');  
      }
  });
  $('.tab-collection-list').slick('unslick');
  collectionTabSlider();
});

// Collection List Slider
function collectionListSlider(){
  $('.index-collection-list').not(".slick-initialized").slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: '220px',
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 1181,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: '150px'
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          centerPadding: '60px',
        }
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 1,
          centerPadding: '15px',
        }
      }
    ]
  });
}
collectionListSlider();


function instagramSlider(){
  $('.index-instagram-list').not(".slick-initialized").slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: '220px',
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1181,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 681,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '40px',
        }
      }
    ]
  });
}
instagramSlider();

// B2B Image Banner Slider
function imageBannerSlider(){
  $('.section-image-banner-slider .image-banner-slider').not(".slick-initialized").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrows: false
        }
      }
    ]
  });
}
imageBannerSlider();

// Stone Slider
function stoneSlider(){
  $('.section-natural-stone .stone_grid').not(".slick-initialized").slick({
    dots: false,
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '60px',
      }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px',
        }
      }
    ]
  });
}
stoneSlider();

function initializeStoneProductSlider(){
  $('.stone-drawer .drawer-products').not(".slick-initialized").slick({
    dots: false,
    infinite: false,
    centerMode: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1
        }
      }
    ]
  });
}
// stoneProductSlider();

$(document).on('click','.section-natural-stone .stone-grid-wrapper.enable_drawer', function(){
   var getTitle = $(this).attr('data-title');
   var getHandle = $(this).attr('data-tab');
   $('.stone-drawer .title h3').html(getTitle);
   $('.stone-drawer').addClass('is-active');
   $('body').addClass('drawer_open');
   $('.theme-overlay').addClass('is-active');


   $('.drawer-content-items .drawer-content-item').each(function(){
      var selfHandle = $(this).attr('data-tab');
      if(getHandle == selfHandle){
        $(this).addClass('is-active');
      }else{
        $(this).removeClass('is-active');
      }
   });

 // Reinitialize the slider to fix issues
  var $drawerProducts = $('.stone-drawer .drawer-products');

  if ($drawerProducts.hasClass('slick-initialized')) {
    $drawerProducts.slick('unslick');
  }

  setTimeout(function () {
    initializeStoneProductSlider();
  }, 300);
  
});


$(document).on('click','.stone-drawer .close_btn', function(){
   $(this).parents('.stone-drawer').removeClass('is-active');
   $('body').removeClass('drawer_open');
   $('.theme-overlay').removeClass('is-active');
});
$(document).on('click', '.theme-overlay', function(){
   $('.stone-drawer').removeClass('is-active');
   $('#facets-drawer').removeClass('is-active');
   $('body').removeClass('drawer_open');
   $(this).removeClass('is-active');
});

$(document).on('click', '.drawer-tab-wrapper .accordian_title', function () {
    const $this = $(this);
    const $content = $this.siblings('.accordian_content');
    
    $('.drawer-tab-wrapper .accordian_content').not($content).slideUp(500);
    $content.slideToggle(500);
});



$(document).on('click', '.stone-drawer .slide-change_btn', function () {
    var getPosition = $(this).attr('data-position');

    var $currentSlide = $('.drawer-content-item.is-active');
    var currentIndex = parseInt($currentSlide.attr('data-index'), 10);

    if (getPosition === 'right') {
        var $nextSlide = $('.drawer-content-item[data-index="' + (currentIndex + 1) + '"]');
        var $nextSlideTitle = $nextSlide.attr('data-title');
        $(this).siblings('.title').find('.h3').text($nextSlideTitle);

        if ($nextSlide.length) {
            $currentSlide.removeClass('is-active');
            $nextSlide.addClass('is-active');
        }
    } else if (getPosition === 'left') {
        var $prevSlide = $('.drawer-content-item[data-index="' + (currentIndex - 1) + '"]');
        var $prevSlideTitle = $prevSlide.attr('data-title');
        $(this).siblings('.title').find('.h3').text($prevSlideTitle);
        if ($prevSlide.length) {
            $currentSlide.removeClass('is-active');
            $prevSlide.addClass('is-active');
        }
    }

    // stoneProductSlider();
   // Reinitialize the slider to fix issues
    var $drawerProducts = $('.stone-drawer .drawer-products');
  
    if ($drawerProducts.hasClass('slick-initialized')) {
      $drawerProducts.slick('unslick');
    }
  
    setTimeout(function () {
      initializeStoneProductSlider();
    }, 300);
  
});

// Product Personalize
// $(document).on('click', '.collection-toolbar__button', function () {
//   $(this).addClass('is-active');
//   $('.collection-toolbar__button').not($(this)).removeClass('is-active');

//   var getVal = $(this).val(); 
//   var getMobileVal = $(this).attr('data-mobile-val');
//   var getGridClass = $('#index-product-grid').attr('class');
//   var updatedGridClass = getGridClass.replace(/grid--\d+-col-desktop/, `grid--${getVal}-col-desktop`);
//   updatedGridClass = updatedGridClass.replace(/grid--\d+-col-mobile/, `grid--${getMobileVal}-col-mobile`);
//   $('#index-product-grid').attr('class', updatedGridClass);
// });

// window.addEventListener('load', function () {
//   const mobileBreakpoint = 768; 
//   if (window.innerWidth < mobileBreakpoint) {
//     $('.collection-toolbar__button[data-mobile-val="2"]').addClass('is-active');
//     $('.collection-toolbar__button[data-mobile-val="1"]').removeClass('is-active');
//     const productGrid = document.querySelector(
//     '.index-featured-collection .grid.product-grid'
//     );
//     if (productGrid) {
//       productGrid.classList.replace('grid--1-col-mobile', 'grid--2-col-mobile');
//     }
//   }
// });

$(document).on('click', '.collection-toolbar__button', function () {
  $(this).addClass('is-active');
  $('.collection-toolbar__button').not($(this)).removeClass('is-active');

  var getVal = $(this).val(); 
  var getMobileVal = $(this).attr('data-mobile-val');

  $('ul.grid--view-items').each(function () {
    var getGridClass = $(this).attr('class');
    var updatedGridClass = getGridClass.replace(/grid--\d+-col-desktop/, `grid--${getVal}-col-desktop`);
    updatedGridClass = updatedGridClass.replace(/grid--\d+-col-mobile/, `grid--${getMobileVal}-col-mobile`);
    $(this).attr('class', updatedGridClass);
  });
});

window.addEventListener('load', function () {
  const mobileBreakpoint = 768; 
  if (window.innerWidth < mobileBreakpoint) {
    $('.collection-toolbar__button[data-mobile-val="2"]').addClass('is-active');
    $('.collection-toolbar__button[data-mobile-val="1"]').removeClass('is-active');

    $('ul.grid--view-items').each(function () {
      var getGridClass = $(this).attr('class');
      var updatedGridClass = getGridClass.replace(/grid--\d+-col-mobile/, 'grid--2-col-mobile');
      $(this).attr('class', updatedGridClass);
    });
  }
});


$(document).on('click', '.personalize-product-group .personalize-product__item', function () {
  $(this).addClass('is-active');
  $('.personalize-product__item').not($(this)).removeClass('is-active');

  let getFeaturedImage = $(this).attr('data-image');
  if(getFeaturedImage) {
    $('#personalize-product__image img').attr('src',getFeaturedImage);
    $('#personalize-product__image img').attr('srcset',getFeaturedImage);
  }
  var finalLevel = $(this).parents(".variant-option-group").attr("data-final-lavel");
  $(".product-personalize__btn").attr("data-final-lavel",finalLevel)
  
  $(this).parents('.group-wrapper__inner').siblings('.product-personalize__btn').removeAttr('disabled');
  
});

$(document).on('click', '.product-personalize__btn', function(){
   var getLavel = $(this).attr('data-lavel');
   var getFinalLavel = $(this).attr('data-final-lavel');
   var getProductId = 
    $(this).parents('.btn_group').length
        ? $(this).parents('.btn_group').siblings('.group-wrapper__inner').find('.personalize-product__item.is-active').attr('data-id')
        : $(this).siblings('.group-wrapper__inner').find('.personalize-product__item.is-active').attr('data-id');

   $('.product-form-wrapper .product-form__content').attr('data-product-id',getProductId);
   if(getLavel == 0){
      $('.product-group-wrapper').removeClass('is-active');
      $('.variant-group-wrapper').addClass('is-active');

      $('.variant-group-wrapper .variant-option-group').each(function() {
          var eachProductId = $(this).attr('data-product-id');
          var eachLavel = $(this).attr('data-lavel');
          
          if (getProductId == eachProductId && eachLavel == "1") {
             $(this).addClass('is-active'); 
          } else {
             $(this).removeClass('is-active'); 
          }
      });
      $('.variant-group-wrapper .product-personalize__btn').attr('data-lavel','1');
   }else if(getLavel == 1){
      $('.variant-group-wrapper .variant-option-group').each(function() {
          var eachProductId = $(this).attr('data-product-id');
          var eachLavel = $(this).attr('data-lavel');
          
          if (getProductId == eachProductId && eachLavel == "2") {
             $(this).addClass('is-active'); 
          } else {
             $(this).removeClass('is-active'); 
          }
      });


    //  console.log(getFinalLavel,'getFinalLavel');

     if(getFinalLavel == "2" && getFinalLavel != undefined){
        $(this).attr({
         'data-lavel': '3',
         'disabled': 'disabled'
        });
     }else{
       $(this).attr({
         'data-lavel': '2',
         'disabled': 'disabled'
        });
     }

   }else if(getLavel == 2){
      $('.variant-group-wrapper .variant-option-group').each(function() {
          var eachProductId = $(this).attr('data-product-id');
          var eachLavel = $(this).attr('data-lavel');
          
          if (getProductId == eachProductId && eachLavel == "3") {
             $(this).addClass('is-active'); 
          } else {
             $(this).removeClass('is-active'); 
          }
      });
      $(this).attr({
       'data-lavel': '3',
       'disabled': 'disabled'
      });

   }else if(getLavel == 3){
       $('.personalize-product-group .product-group-wrapper').removeClass('is-active');
       $('.personalize-product-group .variant-group-wrapper').removeClass('is-active');
       $('.personalize-product-group .product-form-wrapper').addClass('is-active');
       $('.personalize-product__heading').css('display', 'none');
       $('.personalize-product__text').css('display', 'none');
       $('.personalize-product-wrapper .label h4').css('display', 'none');
       $('.personalize-collection-products .label h4').css('display', 'none');
       // $('.personalize-collection-popup .back-to-site__btn').css('display', 'none');
  
       var getModel = $('.personalize-product__item input[name="model"]:checked').val(),
           getModelPrice = $('.personalize-product__item input[name="model"]:checked').attr('data-price'),
           getModelId = $('.personalize-product__item input[name="model"]:checked').attr('data-id'),
           getNaturalStone = $('.personalize-product__item input[name="naturalstone"]:checked').val(),
           getFrame = $('.personalize-product__item input[name="frame"]:checked').val(),
           getSize = $('.personalize-product__item input[name="size"]:checked').val(),
           getProductId = $('.personalize-product__item input[name="size"]:checked').attr('data-product-id');
           
  
      //  console.log(getModel,'getModel',getNaturalStone,getFrame,getSize);
  
       const options = [
          { value: getModel, selector: '.product-form-item.model' },
          { value: getNaturalStone, selector: '.product-form-item.natural_stone' },
          { value: getFrame, selector: '.product-form-item.frame' },
          { value: getSize, selector: '.product-form-item.size' },
       ];
      
       options.forEach(option => {
          if (option.value) {
              $(`.product-form-wrapper ${option.selector} .option-value`).text(option.value);
              $(`.product-form-wrapper ${option.selector}`).addClass('is-active');
          }
       });

      // console.log(getNaturalStone,getFrame,getSize,'getSizegetSize'); 

      if(getNaturalStone == undefined){
        var setOption = `${getFrame} / ${getSize}`;
      }else if(getFrame == undefined){
        var setOption = `${getNaturalStone} / ${getSize}`;
      }else if(getSize == undefined){
        var setOption = `${getNaturalStone} / ${getFrame}`;
      }else{
        var setOption = `${getNaturalStone} / ${getFrame} / ${getSize}`;
      }
     
      var optionPrice = null; 
      var optionComparePrice = null; 
      var optionId = null; 
      var optionImage = null; 
  
      $('.product-group-wrapper select').each(function () {
          var getSelectId = $(this).attr('data-product-id');
          if (getSelectId == getProductId) {
              $(this).find('option').each(function () {
                  var optionText = $(this).text();
                  if (optionText.includes(setOption)) { 
                      optionPrice = $(this).attr('data-price');
                      optionComparePrice = $(this).attr('data-compare-price');
                      optionImage = $(this).attr('data-image');
                      optionId = $(this).val();
                  }
              });
          }
      });

     // console.log(optionId,'optionId');
      $('.product-form-price_wrapper .price-sale').html(theme.Currency.formatMoney(optionPrice, theme.moneyFormat));
      if(optionComparePrice){
        $('.product-form-price_wrapper .product-original-sale').html(theme.Currency.formatMoney(optionComparePrice, theme.moneyFormat));
      }
      $('.product-form-wrapper .product-form-final-image img').attr('src',optionImage);
      $('.product-form-wrapper .product-form-final-image img').attr('data-src',optionImage);
      $('.personalize-product-group .product-form__footer a.btn').attr('data-id',optionId);
     
   }
});


$(document).on('click', '.product-form-wrapper a.option-change', function(e) {
  e.preventDefault();

  $('.personalize-product__heading').css('display', 'block');
  $('.personalize-product__text').css('display', 'block');
  $('.personalize-product-wrapper .label h4').css('display', 'block');

  var getSlide = $(this).attr('data-slide');
  var getProductId = $(this).parents('.product-form__content').attr('data-product-id');
  
  // console.log(getSlide, 'getSlide');

  $(this).parents('.product-form-wrapper').removeClass('is-active');
  
  if (getSlide === 'model') {
    $(this).parents('.product-form-wrapper').siblings('.product-group-wrapper').addClass('is-active');
  } else if (getSlide === 'natural_stone' || getSlide === 'frame' || getSlide === 'size') {
    var lavelValue = getSlide === 'natural_stone' ? 1 : getSlide === 'frame' ? 2 : 3;
    var $variantGroupWrapper = $(this).parents('.product-form-wrapper').siblings('.variant-group-wrapper');
    
    $variantGroupWrapper.find(`.variant-option-group[data-product-id="${getProductId}"]`).removeClass('is-active');
    
    $variantGroupWrapper.addClass('is-active');
    $variantGroupWrapper.find(`.variant-option-group[data-product-id="${getProductId}"][data-lavel="${lavelValue}"]`).addClass('is-active');
  }
});

$(".personalize-product-group .product-form__footer a.btn").click(function(e){
      e.preventDefault()
      $.ajax({
      type: 'POST', 
      url: '/cart/add',
      dataType: 'json', 
      data: {id: $(this).data('id'),quantity:1},
      success: function(data){
        window.location = '/cart';
      }
   });
});


function personalizeProductSlider() {
  const sliderSelector = $('.personalize-product__product .product-group-wrapper .group-wrapper__inner');
  
  if ($(window).width() <= 991) {
    if (!sliderSelector.hasClass('slick-initialized')) {
      sliderSelector.slick({
        dots: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 2,
        centerPadding: '60px',
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerPadding: '40px',
            }
          }
        ]
      });
    }
  } else {
    if (sliderSelector.hasClass('slick-initialized')) {
      sliderSelector.slick('unslick');
    }
  }
}

// Initialize and handle resize events
$(document).ready(function () {
  personalizeProductSlider();
  $(window).resize(function () {
    personalizeProductSlider();
  });
});

document.querySelectorAll('.dm-custom-play__button').forEach(button => {
    button.addEventListener('click', function() {
        const parentMedia = this.closest('.product-single__media');
        const playButton = parentMedia ? parentMedia.querySelector('.plyr__control--overlaid') : null;
        
        if (playButton) {
            this.classList.add("hidden")
            playButton.click();
        }
    });
});


$(document).ready(function(){
    $(".product-single__meta .ruk_rating_snippet").click(function() {
        $(".faq-block__reviews").addClass('faq-active');
        $(".faq-block__reviews .faq-info").slideDown();
    });
});


// Default Collection

$(document).on('click','.collection-filter .filter-switch-btn', function(){
   $('#facets-drawer').addClass('is-active');
   $('body').addClass('drawer_open');
   $('.theme-overlay').addClass('is-active');
  
});


$(document).on('click','#facets-drawer .close_btn', function(){
   $(this).parents('#facets-drawer').removeClass('is-active');
   $('body').removeClass('drawer_open');
   $('.theme-overlay').removeClass('is-active');
});

$(document).on('click', '.faceted-filter-group-summary', function () {
    const $this = $(this);
    const $content = $this.siblings('.faceted-filter-group-display');
    
    $('.faceted-filter-group .faceted-filter-group-display').not($content).slideUp(500);
    $content.slideToggle(500);
});

$(document).on('click','.faceted-filter-group-display__list-item-input', function(){
   var selfValue = $(this).val();
   $(this).parents('.faceted-filter-group').find('.faceted-filter-group-summary .selected-value').text(selfValue);
});


// Read More And Read less in Collection 
$(document).ready(function() {
    var showChar = 300; 
    var ellipsestext = "";
    var moretext = "Weiterlesen";
    var lesstext = "Wenigeranzeigen";
    

    $('.collection-details .collection__description p').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
});


$(document).on('click', '.cart__qty_block .quantity__button', function () {
    var selfType = $(this).attr('data-type'); 
    var $input = $(this).siblings('.quantity__input');
    var quantityVal = parseInt($input.val(), 10); 

    if (selfType === 'plus') {
        quantityVal += 1; 
    } else if (selfType === 'minus' && quantityVal > 1) {
        quantityVal -= 1; 
    }

    $input.val(quantityVal);
    $input.trigger("change");
});


$(document).on('click','.video__image', function(){
  $(this).parents('.video__wrapper').addClass('active'); 
    playVideo();
});

$('.section-article-video .article-videos').not(".slick-initialized").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  centerMode: true,
  centerPadding: '60px',
  prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
  nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
  responsive: [
    {
      breakpoint: 1201,
      settings: {
        centerPadding: '20px',
        arrows: true
      }
    }
  ]
});

// Personalize Featured Collection
$('.personalize-featured-collection .personalize-product__grid').not(".slick-initialized").each(function() {
  $(this).slick({
      dots: false,
      infinite: false,
      centerMode: true,
      centerPadding: '150px',
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      prevArrow: '<button class="slide-arrow slick-prev"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z" fill="#000"/></svg></button>',
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            centerPadding: '60px'
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 949,
          settings: {
            slidesToShow: 1,
            arrows: true,
          }
        },
        {
          breakpoint: 640,
          settings: {
           slidesToShow: 1, 
           centerPadding: '40px',
           arrows: true,
          }
        }
      ]
  });
});

$(document).on('click','.product-featured-select-btn a', function(){
  $('.personalize-collection-popup').addClass('active');
  $('body').addClass('personalize-popup-open');
  
  let getFeaturedImage = $(this).attr('data-image');
  if(getFeaturedImage) {
    $('#products-form-v-image img').attr('src',getFeaturedImage);
    $('#products-form-v-image img').attr('srcset',getFeaturedImage);
  }

  var getLavel = $(this).attr('data-lavel');
  var getProductId = $(this).attr('data-id');
  $('.product-form-wrapper .product-form__content').attr('data-product-id',getProductId);

  $('.personalize-product-group .product-form-wrapper').removeClass('is-active');

  $('.personalize-product__heading').css('display', 'block');
  $('.personalize-product__text').css('display', 'block');
  $('.personalize-product-wrapper .label h4').css('display', 'block');
  $('.personalize-collection-products .label h4').css('display', 'block');

  
  if(getLavel == 0){
      $('.personalize-collection-products .variant-group-wrapper').addClass('is-active');
      $('.personalize-collection-products .variant-group-wrapper .variant-option-group').each(function() {
          var eachProductId = $(this).attr('data-product-id');
          var eachLavel = $(this).attr('data-lavel');
          
          if (getProductId == eachProductId && eachLavel == "1") {
             $(this).addClass('is-active'); 
          } else {
             $(this).removeClass('is-active'); 
          }
      });
      $('.variant-group-wrapper .product-personalize__btn').attr('data-lavel','1');
   }
});

$(document).on('click','.personalize-collection-popup .back-to-site__btn', function(){
  $('.personalize-collection-popup').removeClass('active');
  $('body').removeClass('personalize-popup-open');
});

$(document).on('click', '.personalize-collection-products .personalize-product-group .personalize-product__item', function () {
  $(this).parents('.group-wrapper__inner').siblings('.btn_group').find('.product-personalize__btn').removeAttr('disabled');
  let getFeaturedImage = $(this).attr('data-image');
  if(getFeaturedImage) {
    $('#products-form-v-image img').attr('src',getFeaturedImage);
    $('#products-form-v-image img').attr('srcset',getFeaturedImage);
  }
});

function patternMerquery() {
  const patternSelector = $('.section-material-natural-pattern .natural-pattern-wrapper');
  
  if ($(window).width() <= 1221) {
    if (!patternSelector.hasClass('slick-initialized')) {
      patternSelector.slick({
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
      });
    }
  } else {
    if (patternSelector.hasClass('slick-initialized')) {
      patternSelector.slick('unslick');
    }
  }
}
$(document).ready(function () {
  patternMerquery();
  $(window).resize(function () {
    patternMerquery();
  });
});

// DM Meterial Animation Banner

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.section-material-animation-banner');
  if(section){
    const sand = section.querySelector('.material-sand');
    let animated = false;
  
    function triggerAnimation() {
      if (animated) return;
  
      section.classList.add('animate', 'space');
      document.body.classList.add('animate');
  
      setTimeout(() => {
        section.classList.add('opacity-animate');
        document.body.classList.add('opacity-animate');
      }, 1000);
  
      setTimeout(() => {
        section.classList.add('expand');
        document.body.classList.add('expand');
      }, 1500);
  
      setTimeout(() => {
        section.classList.add('show-message');
        document.body.classList.add('show-message');
      }, 2500);
  
      animated = true;
    }
  
    section.addEventListener('mouseenter', triggerAnimation);
  
    section.addEventListener('touchstart', triggerAnimation, { passive: true });
    section.addEventListener('click', triggerAnimation);
  }
});



window.addEventListener('scroll', function () {
  var scrollY = window.scrollY;

  if (scrollY >= 900) {
    $('.section-material-animation-banner').removeClass('space');
    $('body').removeClass('animate');
    $('body').removeClass('opacity-animate');
    $('body').removeClass('expand');
    $('body').removeClass('show-message');
  } 
});

// document.addEventListener('DOMContentLoaded', function () {
// });
if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

let ytPlayers = [];

function onYouTubeIframeAPIReady() {
  document.querySelectorAll(".js-article-youtube").forEach((iframe, index) => {
    ytPlayers[index] = new YT.Player(iframe, {
      events: {
        onStateChange: function (event) {
          // When video starts playing
          if (event.data === YT.PlayerState.PLAYING) {
            const wrapper = iframe.closest(".video__wrapper");
            const infoBox = wrapper.querySelector(".video-info.desktop-content");
            if (infoBox) {
              infoBox.classList.add("hidden");
            }
          }
          // If you also want it to reappear when video is paused/stopped
          if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
            const wrapper = iframe.closest(".video__wrapper");
            const infoBox = wrapper.querySelector(".video-info.desktop-content");
            if (infoBox) {
              infoBox.classList.remove("hidden");
            }
          }
        }
      }
    });
  });
}


// New Mobile Menu
$(document).on('click', '.mobile_nav .mobile_nav_links.custom_mobile_links', function () {
    const $this = $(this);
    const $content = $this.next('.main_menu_link_werapper.submenu-wrap');

    if ($this.hasClass('active')) {
        $this.removeClass('active');
        $content.stop(true, true).slideUp(500);
    } else {
        $('.mobile_nav .mobile_nav_links.custom_mobile_links').removeClass('active');
        $('.mobile_nav .main_menu_link_werapper.submenu-wrap').stop(true, true).slideUp(500);

        $this.addClass('active');
        $content.stop(true, true).slideDown(500);
    }
});


// Black week page mobile slider 

function initCardSlider() {
  const slider = $('.section-main-image-banner .card-media-slider');
  const windowWidth = window.innerWidth;
  if (windowWidth >= 990) {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
    return; 
  }

  if (!slider.hasClass('slick-initialized')) {
    slider.slick({
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: '15px',
      speed: 500,
      slidesToShow: 3.1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1,
            centerPadding: '28px',
          }
        }
      ]
    });
  }
}

initCardSlider();

let resizeTimerr;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimerr);
  resizeTimerr = setTimeout(initCardSlider, 200);
});


// Fetured Product Banner Slider
function initProductTabSlider() {
  const $slider = $('.product-tab-content-wrap');

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.slide-arrow-prev'),
      nextArrow: $('.slide-arrow-next'),
      adaptiveHeight: true
    });
  }

  $('.product-tab-title').on('click', '.tab-link', function (e) {
    e.preventDefault();

    const tabIndex = $(this).data('index'); 
    const slideIndex = parseInt(tabIndex.replace('tab-', ''), 10) - 1;

    $('.product-tab-item').removeClass('is-active');
    $(this).closest('.product-tab-item').addClass('is-active');

    $slider.slick('slickGoTo', slideIndex);
  });

  $slider.on('afterChange', function (event, slick, currentSlide) {
    $('.product-tab-item').removeClass('is-active');
    $('.product-tab-item')
      .eq(currentSlide)
      .addClass('is-active');
  });
}

initProductTabSlider();



